module.exports = "/images/icon-lable.svg?af6872e4b8a7f7acefe616d234947196";